import { render, staticRenderFns } from "./VoiceChat.vue?vue&type=template&id=5a1691fc&scoped=true"
import script from "./VoiceChat.vue?vue&type=script&lang=js"
export * from "./VoiceChat.vue?vue&type=script&lang=js"
import style0 from "./VoiceChat.vue?vue&type=style&index=0&id=5a1691fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1691fc",
  null
  
)

export default component.exports